var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRapidoboxLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_231",
    "data-name": "Group 231",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 768,
    height: 864,
    viewBox: "0 0 768 864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 768,
    height: 864,
    transform: "translate(319 1281)",
    fill: "#387d7a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 768,
    height: 864,
    transform: "translate(9323 870)",
    fill: "#c9e2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#182135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646a78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f25e09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0cab4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_11",
    "data-name": "Mask Group 11",
    transform: "translate(-319 -1281)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(80.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon_408",
    "data-name": "Polygon 408",
    transform: "translate(103.548 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_409",
    "data-name": "Polygon 409",
    transform: "translate(103.548 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_410",
    "data-name": "Polygon 410",
    transform: "translate(103.548 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_411",
    "data-name": "Polygon 411",
    transform: "translate(103.548 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_412",
    "data-name": "Polygon 412",
    transform: "translate(168.399 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_413",
    "data-name": "Polygon 413",
    transform: "translate(168.399 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_414",
    "data-name": "Polygon 414",
    transform: "translate(168.399 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_415",
    "data-name": "Polygon 415",
    transform: "translate(168.399 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_416",
    "data-name": "Polygon 416",
    transform: "translate(622.356 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_417",
    "data-name": "Polygon 417",
    transform: "translate(622.356 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_418",
    "data-name": "Polygon 418",
    transform: "translate(622.356 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_419",
    "data-name": "Polygon 419",
    transform: "translate(622.356 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_420",
    "data-name": "Polygon 420",
    transform: "translate(687.207 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_421",
    "data-name": "Polygon 421",
    transform: "translate(687.207 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_422",
    "data-name": "Polygon 422",
    transform: "translate(687.207 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_423",
    "data-name": "Polygon 423",
    transform: "translate(687.207 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_424",
    "data-name": "Polygon 424",
    transform: "translate(362.952 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_425",
    "data-name": "Polygon 425",
    transform: "translate(362.952 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_426",
    "data-name": "Polygon 426",
    transform: "translate(362.952 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_427",
    "data-name": "Polygon 427",
    transform: "translate(362.952 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_428",
    "data-name": "Polygon 428",
    transform: "translate(427.803 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_429",
    "data-name": "Polygon 429",
    transform: "translate(427.803 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_430",
    "data-name": "Polygon 430",
    transform: "translate(427.803 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_431",
    "data-name": "Polygon 431",
    transform: "translate(427.803 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_432",
    "data-name": "Polygon 432",
    transform: "translate(881.76 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_433",
    "data-name": "Polygon 433",
    transform: "translate(881.76 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_434",
    "data-name": "Polygon 434",
    transform: "translate(881.76 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_435",
    "data-name": "Polygon 435",
    transform: "translate(881.76 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_436",
    "data-name": "Polygon 436",
    transform: "translate(946.61 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_437",
    "data-name": "Polygon 437",
    transform: "translate(946.61 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_438",
    "data-name": "Polygon 438",
    transform: "translate(946.61 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_439",
    "data-name": "Polygon 439",
    transform: "translate(946.61 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_440",
    "data-name": "Polygon 440",
    transform: "translate(233.25 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.503
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_441",
    "data-name": "Polygon 441",
    transform: "translate(233.25 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_442",
    "data-name": "Polygon 442",
    transform: "translate(233.25 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_443",
    "data-name": "Polygon 443",
    transform: "translate(233.25 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_444",
    "data-name": "Polygon 444",
    transform: "translate(298.101 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_445",
    "data-name": "Polygon 445",
    transform: "translate(298.101 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_446",
    "data-name": "Polygon 446",
    transform: "translate(298.101 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_447",
    "data-name": "Polygon 447",
    transform: "translate(298.101 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_448",
    "data-name": "Polygon 448",
    transform: "translate(752.058 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_449",
    "data-name": "Polygon 449",
    transform: "translate(752.058 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_450",
    "data-name": "Polygon 450",
    transform: "translate(752.058 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_451",
    "data-name": "Polygon 451",
    transform: "translate(752.058 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_452",
    "data-name": "Polygon 452",
    transform: "translate(816.909 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_453",
    "data-name": "Polygon 453",
    transform: "translate(816.909 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_454",
    "data-name": "Polygon 454",
    transform: "translate(816.909 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_455",
    "data-name": "Polygon 455",
    transform: "translate(816.909 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_456",
    "data-name": "Polygon 456",
    transform: "translate(492.654 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_457",
    "data-name": "Polygon 457",
    transform: "translate(492.654 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_458",
    "data-name": "Polygon 458",
    transform: "translate(492.654 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_459",
    "data-name": "Polygon 459",
    transform: "translate(492.654 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_460",
    "data-name": "Polygon 460",
    transform: "translate(557.505 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_461",
    "data-name": "Polygon 461",
    transform: "translate(557.505 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_462",
    "data-name": "Polygon 462",
    transform: "translate(557.505 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_463",
    "data-name": "Polygon 463",
    transform: "translate(557.505 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_464",
    "data-name": "Polygon 464",
    transform: "translate(1011.461 1205.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_465",
    "data-name": "Polygon 465",
    transform: "translate(1011.461 1656.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_466",
    "data-name": "Polygon 466",
    transform: "translate(1011.461 1430.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_467",
    "data-name": "Polygon 467",
    transform: "translate(1011.461 1881.125) rotate(30)",
    fill: "none",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_468",
    "data-name": "Polygon 468",
    transform: "translate(1076.313 1318.125) rotate(30)",
    fill: "none",
    opacity: 0.103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_469",
    "data-name": "Polygon 469",
    transform: "translate(1076.313 1769.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_470",
    "data-name": "Polygon 470",
    transform: "translate(1076.313 1543.125) rotate(30)",
    fill: "none",
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_471",
    "data-name": "Polygon 471",
    transform: "translate(1076.313 1994.125) rotate(30)",
    fill: "none",
    opacity: 0.499
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,0,150,65l-37.5,65h-75L0,65,37.5,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 38.07756042480469 1 L 1.15447998046875 65 L 38.07756042480469 129 L 111.9224395751953 129 L 148.8455200195312 65 L 111.9224395751953 1 L 38.07756042480469 1 M 37.5 0 L 112.5 0 L 150 65 L 112.5 130 L 37.5 130 L 0 65 L 37.5 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1286",
    "data-name": "Line 1286",
    y1: 74,
    transform: "translate(136 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.503
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1287",
    "data-name": "Line 1287",
    y1: 74,
    transform: "translate(136 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1288",
    "data-name": "Line 1288",
    y1: 74,
    transform: "translate(136 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1289",
    "data-name": "Line 1289",
    y1: 74,
    transform: "translate(136 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1290",
    "data-name": "Line 1290",
    y1: 74,
    transform: "translate(200.851 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1291",
    "data-name": "Line 1291",
    y1: 74,
    transform: "translate(200.851 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1292",
    "data-name": "Line 1292",
    y1: 74,
    transform: "translate(200.851 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1293",
    "data-name": "Line 1293",
    y1: 74,
    transform: "translate(200.851 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1294",
    "data-name": "Line 1294",
    y1: 74,
    transform: "translate(654.808 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1295",
    "data-name": "Line 1295",
    y1: 74,
    transform: "translate(654.808 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1296",
    "data-name": "Line 1296",
    y1: 74,
    transform: "translate(654.808 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1297",
    "data-name": "Line 1297",
    y1: 74,
    transform: "translate(654.808 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1298",
    "data-name": "Line 1298",
    y1: 74,
    transform: "translate(719.659 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1299",
    "data-name": "Line 1299",
    y1: 74,
    transform: "translate(719.659 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1300",
    "data-name": "Line 1300",
    y1: 74,
    transform: "translate(719.659 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1301",
    "data-name": "Line 1301",
    y1: 74,
    transform: "translate(719.659 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1302",
    "data-name": "Line 1302",
    y1: 74,
    transform: "translate(395.404 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1303",
    "data-name": "Line 1303",
    y1: 74,
    transform: "translate(395.404 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1304",
    "data-name": "Line 1304",
    y1: 74,
    transform: "translate(395.404 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1305",
    "data-name": "Line 1305",
    y1: 74,
    transform: "translate(395.404 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1306",
    "data-name": "Line 1306",
    y1: 74,
    transform: "translate(460.255 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1307",
    "data-name": "Line 1307",
    y1: 74,
    transform: "translate(460.255 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1308",
    "data-name": "Line 1308",
    y1: 74,
    transform: "translate(460.255 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1309",
    "data-name": "Line 1309",
    y1: 74,
    transform: "translate(460.255 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1310",
    "data-name": "Line 1310",
    y1: 74,
    transform: "translate(914.211 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1311",
    "data-name": "Line 1311",
    y1: 74,
    transform: "translate(914.211 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1312",
    "data-name": "Line 1312",
    y1: 74,
    transform: "translate(914.211 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1313",
    "data-name": "Line 1313",
    y1: 74,
    transform: "translate(914.211 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1314",
    "data-name": "Line 1314",
    y1: 74,
    transform: "translate(979.063 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1315",
    "data-name": "Line 1315",
    y1: 74,
    transform: "translate(979.063 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1316",
    "data-name": "Line 1316",
    y1: 74,
    transform: "translate(979.063 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1317",
    "data-name": "Line 1317",
    y1: 74,
    transform: "translate(979.063 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1318",
    "data-name": "Line 1318",
    y1: 74,
    transform: "translate(265.702 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1319",
    "data-name": "Line 1319",
    y1: 74,
    transform: "translate(265.702 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1320",
    "data-name": "Line 1320",
    y1: 74,
    transform: "translate(265.702 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1321",
    "data-name": "Line 1321",
    y1: 74,
    transform: "translate(265.702 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1322",
    "data-name": "Line 1322",
    y1: 74,
    transform: "translate(330.553 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1323",
    "data-name": "Line 1323",
    y1: 74,
    transform: "translate(330.553 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1324",
    "data-name": "Line 1324",
    y1: 74,
    transform: "translate(330.553 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1325",
    "data-name": "Line 1325",
    y1: 74,
    transform: "translate(330.553 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1326",
    "data-name": "Line 1326",
    y1: 74,
    transform: "translate(784.51 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1327",
    "data-name": "Line 1327",
    y1: 74,
    transform: "translate(784.51 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1328",
    "data-name": "Line 1328",
    y1: 74,
    transform: "translate(784.51 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1329",
    "data-name": "Line 1329",
    y1: 74,
    transform: "translate(784.51 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1330",
    "data-name": "Line 1330",
    y1: 74,
    transform: "translate(849.36 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1331",
    "data-name": "Line 1331",
    y1: 74,
    transform: "translate(849.36 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1332",
    "data-name": "Line 1332",
    y1: 74,
    transform: "translate(849.36 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1333",
    "data-name": "Line 1333",
    y1: 74,
    transform: "translate(849.36 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1334",
    "data-name": "Line 1334",
    y1: 74,
    transform: "translate(525.106 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1335",
    "data-name": "Line 1335",
    y1: 74,
    transform: "translate(525.106 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1336",
    "data-name": "Line 1336",
    y1: 74,
    transform: "translate(525.106 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1337",
    "data-name": "Line 1337",
    y1: 74,
    transform: "translate(525.106 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1338",
    "data-name": "Line 1338",
    y1: 74,
    transform: "translate(589.957 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1339",
    "data-name": "Line 1339",
    y1: 74,
    transform: "translate(589.957 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1340",
    "data-name": "Line 1340",
    y1: 74,
    transform: "translate(589.957 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1341",
    "data-name": "Line 1341",
    y1: 74,
    transform: "translate(589.957 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1342",
    "data-name": "Line 1342",
    y1: 74,
    transform: "translate(1043.913 1299.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1343",
    "data-name": "Line 1343",
    y1: 74,
    transform: "translate(1043.913 1750.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1344",
    "data-name": "Line 1344",
    y1: 74,
    transform: "translate(1043.913 1524.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1345",
    "data-name": "Line 1345",
    y1: 74,
    transform: "translate(1043.913 1975.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.499
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1346",
    "data-name": "Line 1346",
    y1: 74,
    transform: "translate(1108.764 1412.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1347",
    "data-name": "Line 1347",
    y1: 74,
    transform: "translate(1108.764 1863.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1348",
    "data-name": "Line 1348",
    y1: 74,
    transform: "translate(1108.764 1637.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1349",
    "data-name": "Line 1349",
    y1: 74,
    transform: "translate(1108.764 2088.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.499
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1350",
    "data-name": "Line 1350",
    y1: 38,
    x2: 64.5,
    transform: "translate(136 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.503
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1351",
    "data-name": "Line 1351",
    y1: 38,
    x2: 64.5,
    transform: "translate(136 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1352",
    "data-name": "Line 1352",
    y1: 38,
    x2: 64.5,
    transform: "translate(136 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1353",
    "data-name": "Line 1353",
    y1: 38,
    x2: 64.5,
    transform: "translate(136 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1354",
    "data-name": "Line 1354",
    y1: 38,
    x2: 64.5,
    transform: "translate(200.851 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1355",
    "data-name": "Line 1355",
    y1: 38,
    x2: 64.5,
    transform: "translate(200.851 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1356",
    "data-name": "Line 1356",
    y1: 38,
    x2: 64.5,
    transform: "translate(200.851 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1357",
    "data-name": "Line 1357",
    y1: 38,
    x2: 64.5,
    transform: "translate(200.851 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1358",
    "data-name": "Line 1358",
    y1: 38,
    x2: 64.5,
    transform: "translate(654.808 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1359",
    "data-name": "Line 1359",
    y1: 38,
    x2: 64.5,
    transform: "translate(654.808 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1360",
    "data-name": "Line 1360",
    y1: 38,
    x2: 64.5,
    transform: "translate(654.808 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1361",
    "data-name": "Line 1361",
    y1: 38,
    x2: 64.5,
    transform: "translate(654.808 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1362",
    "data-name": "Line 1362",
    y1: 38,
    x2: 64.5,
    transform: "translate(719.659 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1363",
    "data-name": "Line 1363",
    y1: 38,
    x2: 64.5,
    transform: "translate(719.659 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1364",
    "data-name": "Line 1364",
    y1: 38,
    x2: 64.5,
    transform: "translate(719.659 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1365",
    "data-name": "Line 1365",
    y1: 38,
    x2: 64.5,
    transform: "translate(719.659 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1366",
    "data-name": "Line 1366",
    y1: 38,
    x2: 64.5,
    transform: "translate(395.404 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1367",
    "data-name": "Line 1367",
    y1: 38,
    x2: 64.5,
    transform: "translate(395.404 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1368",
    "data-name": "Line 1368",
    y1: 38,
    x2: 64.5,
    transform: "translate(395.404 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1369",
    "data-name": "Line 1369",
    y1: 38,
    x2: 64.5,
    transform: "translate(395.404 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1370",
    "data-name": "Line 1370",
    y1: 38,
    x2: 64.5,
    transform: "translate(460.255 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1371",
    "data-name": "Line 1371",
    y1: 38,
    x2: 64.5,
    transform: "translate(460.255 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1372",
    "data-name": "Line 1372",
    y1: 38,
    x2: 64.5,
    transform: "translate(460.255 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1373",
    "data-name": "Line 1373",
    y1: 38,
    x2: 64.5,
    transform: "translate(460.255 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1374",
    "data-name": "Line 1374",
    y1: 38,
    x2: 64.5,
    transform: "translate(914.211 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1375",
    "data-name": "Line 1375",
    y1: 38,
    x2: 64.5,
    transform: "translate(914.211 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1376",
    "data-name": "Line 1376",
    y1: 38,
    x2: 64.5,
    transform: "translate(914.211 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1377",
    "data-name": "Line 1377",
    y1: 38,
    x2: 64.5,
    transform: "translate(914.211 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1378",
    "data-name": "Line 1378",
    y1: 38,
    x2: 64.5,
    transform: "translate(979.063 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1379",
    "data-name": "Line 1379",
    y1: 38,
    x2: 64.5,
    transform: "translate(979.063 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1380",
    "data-name": "Line 1380",
    y1: 38,
    x2: 64.5,
    transform: "translate(979.063 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1381",
    "data-name": "Line 1381",
    y1: 38,
    x2: 64.5,
    transform: "translate(979.063 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.499
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1382",
    "data-name": "Line 1382",
    y1: 38,
    x2: 64.5,
    transform: "translate(265.702 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1383",
    "data-name": "Line 1383",
    y1: 38,
    x2: 64.5,
    transform: "translate(265.702 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1384",
    "data-name": "Line 1384",
    y1: 38,
    x2: 64.5,
    transform: "translate(265.702 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1385",
    "data-name": "Line 1385",
    y1: 38,
    x2: 64.5,
    transform: "translate(265.702 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1386",
    "data-name": "Line 1386",
    y1: 38,
    x2: 64.5,
    transform: "translate(330.553 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1387",
    "data-name": "Line 1387",
    y1: 38,
    x2: 64.5,
    transform: "translate(330.553 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1388",
    "data-name": "Line 1388",
    y1: 38,
    x2: 64.5,
    transform: "translate(330.553 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1389",
    "data-name": "Line 1389",
    y1: 38,
    x2: 64.5,
    transform: "translate(330.553 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1390",
    "data-name": "Line 1390",
    y1: 38,
    x2: 64.5,
    transform: "translate(784.51 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1391",
    "data-name": "Line 1391",
    y1: 38,
    x2: 64.5,
    transform: "translate(784.51 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1392",
    "data-name": "Line 1392",
    y1: 38,
    x2: 64.5,
    transform: "translate(784.51 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1393",
    "data-name": "Line 1393",
    y1: 38,
    x2: 64.5,
    transform: "translate(784.51 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1394",
    "data-name": "Line 1394",
    y1: 38,
    x2: 64.5,
    transform: "translate(849.36 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1395",
    "data-name": "Line 1395",
    y1: 38,
    x2: 64.5,
    transform: "translate(849.36 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1396",
    "data-name": "Line 1396",
    y1: 38,
    x2: 64.5,
    transform: "translate(849.36 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1397",
    "data-name": "Line 1397",
    y1: 38,
    x2: 64.5,
    transform: "translate(849.36 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1398",
    "data-name": "Line 1398",
    y1: 38,
    x2: 64.5,
    transform: "translate(525.106 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1399",
    "data-name": "Line 1399",
    y1: 38,
    x2: 64.5,
    transform: "translate(525.106 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1400",
    "data-name": "Line 1400",
    y1: 38,
    x2: 64.5,
    transform: "translate(525.106 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1401",
    "data-name": "Line 1401",
    y1: 38,
    x2: 64.5,
    transform: "translate(525.106 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1402",
    "data-name": "Line 1402",
    y1: 38,
    x2: 64.5,
    transform: "translate(589.957 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1403",
    "data-name": "Line 1403",
    y1: 38,
    x2: 64.5,
    transform: "translate(589.957 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1404",
    "data-name": "Line 1404",
    y1: 38,
    x2: 64.5,
    transform: "translate(589.957 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1405",
    "data-name": "Line 1405",
    y1: 38,
    x2: 64.5,
    transform: "translate(589.957 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1406",
    "data-name": "Line 1406",
    y1: 38,
    x2: 64.5,
    transform: "translate(1043.913 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1407",
    "data-name": "Line 1407",
    y1: 38,
    x2: 64.5,
    transform: "translate(1043.913 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1408",
    "data-name": "Line 1408",
    y1: 38,
    x2: 64.5,
    transform: "translate(1043.913 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1409",
    "data-name": "Line 1409",
    y1: 38,
    x2: 64.5,
    transform: "translate(1043.913 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1410",
    "data-name": "Line 1410",
    y1: 38,
    x2: 64.5,
    transform: "translate(1108.764 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1411",
    "data-name": "Line 1411",
    y1: 38,
    x2: 64.5,
    transform: "translate(1108.764 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1412",
    "data-name": "Line 1412",
    y1: 38,
    x2: 64.5,
    transform: "translate(1108.764 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1413",
    "data-name": "Line 1413",
    y1: 38,
    x2: 64.5,
    transform: "translate(1108.764 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.499
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1414",
    "data-name": "Line 1414",
    x1: 64.5,
    y1: 38,
    transform: "translate(71.5 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.503
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1415",
    "data-name": "Line 1415",
    x1: 64.5,
    y1: 38,
    transform: "translate(71.5 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1416",
    "data-name": "Line 1416",
    x1: 64.5,
    y1: 38,
    transform: "translate(71.5 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1417",
    "data-name": "Line 1417",
    x1: 64.5,
    y1: 38,
    transform: "translate(71.5 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1418",
    "data-name": "Line 1418",
    x1: 64.5,
    y1: 38,
    transform: "translate(136.351 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1419",
    "data-name": "Line 1419",
    x1: 64.5,
    y1: 38,
    transform: "translate(136.351 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1420",
    "data-name": "Line 1420",
    x1: 64.5,
    y1: 38,
    transform: "translate(136.351 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1421",
    "data-name": "Line 1421",
    x1: 64.5,
    y1: 38,
    transform: "translate(136.351 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1422",
    "data-name": "Line 1422",
    x1: 64.5,
    y1: 38,
    transform: "translate(590.308 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1423",
    "data-name": "Line 1423",
    x1: 64.5,
    y1: 38,
    transform: "translate(590.308 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1424",
    "data-name": "Line 1424",
    x1: 64.5,
    y1: 38,
    transform: "translate(590.308 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1425",
    "data-name": "Line 1425",
    x1: 64.5,
    y1: 38,
    transform: "translate(590.308 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1426",
    "data-name": "Line 1426",
    x1: 64.5,
    y1: 38,
    transform: "translate(655.159 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1427",
    "data-name": "Line 1427",
    x1: 64.5,
    y1: 38,
    transform: "translate(655.159 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1428",
    "data-name": "Line 1428",
    x1: 64.5,
    y1: 38,
    transform: "translate(655.159 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1429",
    "data-name": "Line 1429",
    x1: 64.5,
    y1: 38,
    transform: "translate(655.159 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1430",
    "data-name": "Line 1430",
    x1: 64.5,
    y1: 38,
    transform: "translate(330.904 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1431",
    "data-name": "Line 1431",
    x1: 64.5,
    y1: 38,
    transform: "translate(330.904 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1432",
    "data-name": "Line 1432",
    x1: 64.5,
    y1: 38,
    transform: "translate(330.904 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1433",
    "data-name": "Line 1433",
    x1: 64.5,
    y1: 38,
    transform: "translate(330.904 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1434",
    "data-name": "Line 1434",
    x1: 64.5,
    y1: 38,
    transform: "translate(395.755 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1435",
    "data-name": "Line 1435",
    x1: 64.5,
    y1: 38,
    transform: "translate(395.755 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1436",
    "data-name": "Line 1436",
    x1: 64.5,
    y1: 38,
    transform: "translate(395.755 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1437",
    "data-name": "Line 1437",
    x1: 64.5,
    y1: 38,
    transform: "translate(395.755 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1438",
    "data-name": "Line 1438",
    x1: 64.5,
    y1: 38,
    transform: "translate(849.711 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1439",
    "data-name": "Line 1439",
    x1: 64.5,
    y1: 38,
    transform: "translate(849.711 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1440",
    "data-name": "Line 1440",
    x1: 64.5,
    y1: 38,
    transform: "translate(849.711 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1441",
    "data-name": "Line 1441",
    x1: 64.5,
    y1: 38,
    transform: "translate(849.711 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1442",
    "data-name": "Line 1442",
    x1: 64.5,
    y1: 38,
    transform: "translate(914.563 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1443",
    "data-name": "Line 1443",
    x1: 64.5,
    y1: 38,
    transform: "translate(914.563 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1444",
    "data-name": "Line 1444",
    x1: 64.5,
    y1: 38,
    transform: "translate(914.563 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1445",
    "data-name": "Line 1445",
    x1: 64.5,
    y1: 38,
    transform: "translate(914.563 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1446",
    "data-name": "Line 1446",
    x1: 64.5,
    y1: 38,
    transform: "translate(201.202 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.503
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1447",
    "data-name": "Line 1447",
    x1: 64.5,
    y1: 38,
    transform: "translate(201.202 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1448",
    "data-name": "Line 1448",
    x1: 64.5,
    y1: 38,
    transform: "translate(201.202 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1449",
    "data-name": "Line 1449",
    x1: 64.5,
    y1: 38,
    transform: "translate(201.202 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1450",
    "data-name": "Line 1450",
    x1: 64.5,
    y1: 38,
    transform: "translate(266.053 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1451",
    "data-name": "Line 1451",
    x1: 64.5,
    y1: 38,
    transform: "translate(266.053 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1452",
    "data-name": "Line 1452",
    x1: 64.5,
    y1: 38,
    transform: "translate(266.053 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1453",
    "data-name": "Line 1453",
    x1: 64.5,
    y1: 38,
    transform: "translate(266.053 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1454",
    "data-name": "Line 1454",
    x1: 64.5,
    y1: 38,
    transform: "translate(720.01 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1455",
    "data-name": "Line 1455",
    x1: 64.5,
    y1: 38,
    transform: "translate(720.01 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1456",
    "data-name": "Line 1456",
    x1: 64.5,
    y1: 38,
    transform: "translate(720.01 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1457",
    "data-name": "Line 1457",
    x1: 64.5,
    y1: 38,
    transform: "translate(720.01 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1458",
    "data-name": "Line 1458",
    x1: 64.5,
    y1: 38,
    transform: "translate(784.86 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1459",
    "data-name": "Line 1459",
    x1: 64.5,
    y1: 38,
    transform: "translate(784.86 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1460",
    "data-name": "Line 1460",
    x1: 64.5,
    y1: 38,
    transform: "translate(784.86 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1461",
    "data-name": "Line 1461",
    x1: 64.5,
    y1: 38,
    transform: "translate(784.86 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1462",
    "data-name": "Line 1462",
    x1: 64.5,
    y1: 38,
    transform: "translate(460.606 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.305
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1463",
    "data-name": "Line 1463",
    x1: 64.5,
    y1: 38,
    transform: "translate(460.606 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1464",
    "data-name": "Line 1464",
    x1: 64.5,
    y1: 38,
    transform: "translate(460.606 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1465",
    "data-name": "Line 1465",
    x1: 64.5,
    y1: 38,
    transform: "translate(460.606 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1466",
    "data-name": "Line 1466",
    x1: 64.5,
    y1: 38,
    transform: "translate(525.457 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1467",
    "data-name": "Line 1467",
    x1: 64.5,
    y1: 38,
    transform: "translate(525.457 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1468",
    "data-name": "Line 1468",
    x1: 64.5,
    y1: 38,
    transform: "translate(525.457 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1469",
    "data-name": "Line 1469",
    x1: 64.5,
    y1: 38,
    transform: "translate(525.457 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1470",
    "data-name": "Line 1470",
    x1: 64.5,
    y1: 38,
    transform: "translate(979.413 1261.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1471",
    "data-name": "Line 1471",
    x1: 64.5,
    y1: 38,
    transform: "translate(979.413 1712.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1472",
    "data-name": "Line 1472",
    x1: 64.5,
    y1: 38,
    transform: "translate(979.413 1486.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1473",
    "data-name": "Line 1473",
    x1: 64.5,
    y1: 38,
    transform: "translate(979.413 1937.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1474",
    "data-name": "Line 1474",
    x1: 64.5,
    y1: 38,
    transform: "translate(1044.264 1374.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1475",
    "data-name": "Line 1475",
    x1: 64.5,
    y1: 38,
    transform: "translate(1044.264 1825.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.298
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1476",
    "data-name": "Line 1476",
    x1: 64.5,
    y1: 38,
    transform: "translate(1044.264 1599.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.103
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1477",
    "data-name": "Line 1477",
    x1: 64.5,
    y1: 38,
    transform: "translate(1044.264 2050.417)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.499
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-9323 -870)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M479.987,272.029q0,43.518-31.614,71.274c-20.906,18.454-46.21,27.816-75.641,27.816H325.445c-29.819,0-54.883-9.033-74.982-27.158q-32.3-28.444-32.242-71.932V103.072c0-22.223-12.592-33.439-37.805-33.439H132.5c-25.184,0-37.865,11.216-37.865,33.439V364.449a6.676,6.676,0,0,1-6.67,6.67H32.036a6.676,6.676,0,0,1-6.67-6.67V103.072c0-28.982,10.438-52.7,31.524-71.244q31.719-27.771,75.88-27.7h48c29.491,0,54.794,9.182,75.91,27.726q31.494,27.86,31.554,71.453l-.658,169.256c0,21.983,12.771,32.9,38.284,32.9H373c24.914,0,37.6-10.917,37.6-32.9V10.8a6.676,6.676,0,0,1,6.67-6.67h56.05a6.676,6.676,0,0,1,6.67,6.67Z",
    transform: "translate(9091.944 1570.26) rotate(-45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M342.5,191.01q0,30.357-22.053,49.719c-14.584,12.873-32.235,19.4-52.765,19.4H234.693c-20.8,0-38.285-6.3-52.306-18.944Q159.855,221.346,159.9,191.01V73.15c0-15.5-8.784-23.326-26.372-23.326H100.1c-17.567,0-26.414,7.824-26.414,23.326v182.33a4.657,4.657,0,0,1-4.653,4.653H30.019a4.657,4.657,0,0,1-4.653-4.653V73.15c0-20.217,7.281-36.762,21.991-49.7Q69.483,4.08,100.288,4.132h33.487c20.572,0,38.223,6.405,52.953,19.341q21.97,19.435,22.011,49.844l-.459,118.069c0,15.335,8.909,22.95,26.706,22.95h32.882c17.38,0,26.226-7.615,26.226-22.95V8.785a4.657,4.657,0,0,1,4.653-4.653h39.1A4.657,4.657,0,0,1,342.5,8.785Z",
    transform: "translate(9720.908 1057.628) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M342.5,191.01q0,30.357-22.053,49.719c-14.584,12.873-32.235,19.4-52.765,19.4H234.693c-20.8,0-38.285-6.3-52.306-18.944Q159.855,221.346,159.9,191.01V73.15c0-15.5-8.784-23.326-26.372-23.326H100.1c-17.567,0-26.414,7.824-26.414,23.326v182.33a4.657,4.657,0,0,1-4.653,4.653H30.019a4.657,4.657,0,0,1-4.653-4.653V73.15c0-20.217,7.281-36.762,21.991-49.7Q69.483,4.08,100.288,4.132h33.487c20.572,0,38.223,6.405,52.953,19.341q21.97,19.435,22.011,49.844l-.459,118.069c0,15.335,8.909,22.95,26.706,22.95h32.882c17.38,0,26.226-7.615,26.226-22.95V8.785a4.657,4.657,0,0,1,4.653-4.653h39.1A4.657,4.657,0,0,1,342.5,8.785Z",
    transform: "translate(9751.908 1206.995) rotate(-45)",
    fill: "url(#linear-gradient-3)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidoboxLogin);
export default __webpack_public_path__ + "static/media/rapidobox-login.fe6403daf714d30eb2231b9067c6d35e.svg";
export { ForwardRef as ReactComponent };